<template>

<app-page v-if="is.loaded" :title="page.customer_title" :description="page.customer_intro">

	<app-inner :center="true" :condensed="true">

		<app-column>

			<app-text>

				<app-message :error="true" v-if="is.errored">

					One or more fields are invalid. Please review and try again.

				</app-message>

				<app-group>

					<app-input-text v-model="inputs.name" :errored="errored.name" :placeholder="page.customer_name_placeholder" />
					<app-input-text v-model="inputs.email" :errored="errored.email" :placeholder="page.customer_email_placeholder" />
					<app-input-text v-model="inputs.phone" :errored="errored.phone" :placeholder="page.customer_phone_placeholder" />
					<app-input-select v-model="inputs.county" :errored="errored.county" :options="data.counties" :placeholder="page.customer_county_placeholder" />
					<app-input-password note="Must be at least 8 characters and include at least one letter and one number." v-model="inputs.password" :errored="errored.password" :placeholder="page.customer_password_placeholder" />
					<app-input-password v-model="inputs.passwordConfirm" :errored="errored.password" :placeholder="page.customer_confirm_placeholder" />
					<app-input-check v-model="inputs.offers" :label="page.customer_discount_label" />

				</app-group>

			</app-text>

			<app-text v-html="page.customer_agreement" :spaced="true" />

			<app-text :spaced="true">

				<app-group :row="true" :center="true">

					<app-button :text="page.customer_button_submit" :loading="is.submitting" :disabled="!is.valid" v-on:click="onJoinClick" />
					<app-button to="Login/Customer" :text="page.customer_button_back" theme="plain" />

				</app-group>

			</app-text>

		</app-column>

	</app-inner>

</app-page>

</template>

<script>

import mixinPage from '@/mixin/page.js'
import mixinForm from '@/mixin/form.js'

export default {

	mixins: [mixinPage, mixinForm],

	data: function() {

		return {
			inputs: {
				name: '',
				email: '',
				phone: '',
				county: 0,
				password: '',
				passwordConfirm: '',
				offers: 0
			},
			rules: {
				name: {
					required: true
				},
				email: {
					required: true
				},
				phone: {
					required: true
				},
				county: {
					required: true
				},
				password: {
					required: true,
					password: true,
					minlength: 8,
					match: 'passwordConfirm'
				},
				passwordConfirm: {
					required: true,
					password: true,
					minlength: 8,
					match: 'password'
				}
			}
		}

	},

	methods: {

		onJoinClick: function() {

			this.save('join', {
				data: this.inputs,
				context: this.context
			}).then(function() {

                if (this.$route.query.redirect) {

                    this.$router.push({
                        path: this.$route.query.redirect
                    })

                } else {

                    this.$router.push({
                        name: 'Dashboard'
                    })

                }

			}.bind(this))

		}

	}

}

</script>